import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/safe-driving-vDSP/SafeDrivingMonthlyScoreTrend/.eu';
import Kr from '@di-shared/features/safe-driving-vDSP/SafeDrivingMonthlyScoreTrend/.kr';

export interface SafeDrivingMonthlyScoreTrendProps {
  vin: string;
}

export default function SafeDrivingMonthlyScoreTrend({vin}: SafeDrivingMonthlyScoreTrendProps) {
  return (
    <>
      <Environment.Kr>
        <Kr vin={vin} />
      </Environment.Kr>
      <Environment.Eu>
        <Eu vin={vin} />
      </Environment.Eu>
    </>
  );
}
